import axios from './httpConfig.js'
export * from "./customer";    // 客户管理
export * from "./basicSets";   // 基本设置
export * from "./products";    // 货品管理
export * from "./warehouse";   // 库房管理
export * from "./stockIn";    // 入库管理(因出入库按配置方式写，出库，入库接口单独写)
export * from "./stockOut";    // 出库管理
export * from "./disassembly";    // 拆卸单
export * from "./assemble";    // 组装单
export * from "./outAdIn";    // 出入库管理
export * from "./systemParam"; // 系统参数管理
export * from "./openService"; // 开放服务
export * from "./erp"; // ERP对接
export * from "./home"; // 首页

// 获取图片验证码
export function GetCheckCode() {
  return axios.post('/public/getCheckcode')
}

// 登录
export function Login(param) {
  return axios.post('/login', param)
}

// 登出
export function Logout() {
  return axios.post('/logout')
}

// 获取 软件系统关于信息
export function GetSystemInfo() {
  return axios.post('/public/getSystemInfo')
}

// 修改密码
export function ChangePassWrod(param) {
  return axios.post('/admin/user/edit/pass', param);
}

// 修改个人信息
export function ChangeUserMessage(param) {
  return axios.post('/admin/user/edit/info', param);
}

// 单点登录绑定验证接口
export function ToAuth(param) {
  return axios.post('/sso/checking', param);
}

// ******************表格自定义******************/

// 界面自定义管理-设置并启用
export function setSelfConfig(param) {
  return axios.post('/admin/window/list/config', param);
}

// 界面自定义管理-删除自定义配置
export function DeleteSelfConfig(param) {
  return axios.post('/admin/window/list/config/delete', param);
}

// 界面自定义管理-启用系统配置
export function ChoseSystemConfig(param) {
  return axios.post('/admin/window/list/config/system', param);
}

// 界面自定义管理-启用自定义配置
export function ChoseSelfConfig(param) {
  return axios.post('/admin/window/list/config/diy', param);
}